import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Catalog } from "@/components/site/Catalog";
import { Lavorazioni } from "@/components/site/Lavorazioni";
import { PortreteTeaser } from "@/components/site/PortreteTeaser";
import { Processo } from "@/components/site/Processo";
import { Bottega } from "@/components/site/Bottega";
import { Contatti } from "@/components/site/Contatti";
import { scrollToId } from "@/components/site/ui";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 350);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main>
      <Hero />
      <Marquee />
      <Catalog />
      <Lavorazioni />
      <PortreteTeaser />
      <Processo />
      <Bottega />
      <Contatti />
    </main>
  );
}
